import { Accordion, AccordionSummary } from '@material-ui/core';
import styled from 'styled-components';

import { constants } from '../../..';

export const StyledAccordion = styled(Accordion)`
  &.MuiPaper-root {
    font-family: ${constants.sourceSansPro};
    background-color: inherit;
    box-shadow: unset;
    border: 0;
  }

  &.MuiAccordion-root {
    margin-bottom: 0;
  }

  &.MuiAccordion-root:before {
    height: 0;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    width: fit-content;
    justify-content: flex-start;
    font-weight: bold;
    font-size: ${constants.LARGE};

    .MuiAccordionSummary-content {
      flex-grow: 0;
    }
  }
`;
